export default {
  'menu.home': 'HOME',
  'menu.chiselDetail': 'CHISEL',
  'menu.otherParts': 'OTHER PARTS',
  'menu.prodTech': 'PRODUCTION TECHNOLOGICAl',
  'menu.service': 'SERVICE',
  'menu.aboutUs': 'ABOUT US',
  'menu.exhibitionDetail': 'Exhibition DETAILS'
}
